<template>
  <b-table :items="arquivos"
           :fields="fields"
           responsive
           striped>
    <template slot="documento"
              slot-scope="data">
      <div class="documento-box">
        {{ data.item.fileName ? data.item.fileName : '---' }}
        <div v-if="data.item.error && data.item.status != 'STATUS_SUCCESS'"
             class="w-100">
          <p class="text-danger">
            Não foi possível importar este arquivo.
          </p>

          <ServerError :error="data.item.error" />
        </div>
      </div>    
    </template>

    <template slot="data_documento"
              slot-scope="data">
      <input :id="`data_averbacao_${data.index}`"
             v-model="data.item.data_documento"
             v-mask="'##/##/####'"
             v-validate="`date_format:dd/MM/yyyy|date_between:01/01/1500,${limitDate}|max_date:${new Date()}`"
             type="text"
             :disabled="disableDataDoc(data)"
             :name="`data_averbacao_${data.index}`"
             :class="{ 'is-invalid': errors.has(`data_averbacao_${data.index}`) }"
             class="form-control form-control-sm col-8"
             placeholder="00/00/0000"
             :required="data.item.data_documento ? true : false"
             @change="changeDataAverb(data)">

      <small v-if="errors.has(`data_averbacao_${data.index}`)"
             class="invalid-feedback changePostIconSvg">
        {{ errors.first(`data_averbacao_${data.index}`) }}
      </small>
    </template>

    <template slot="registro"
              slot-scope="data">
      <span>{{ data.item.registro.termo }}</span>
    </template>

    <template slot="status"
              slot-scope="data">
      <svg v-if="data.item.status === STATUS_PENDING"
           class="icon icon--md"
           role="presentation">
        <use :xlink:href="'#' + cloud_upload.id" />
      </svg>

      <svg v-if="data.item.status === STATUS_SUCCESS"
           class="icon icon--md"
           role="presentation">
        <use :xlink:href="'#' + cloud_check.id" />
      </svg>

      <svg v-if="data.item.status === STATUS_ERROR"
           class="icon icon--md"
           role="presentation">
        <use :xlink:href="'#' + cloud_error.id" />
      </svg>
    </template>

    <template slot="perfil"
              slot-scope="data">
      <select id="perfil"
              v-validate="'required'"
              class="custom-select custom-select-sm mr-2"
              :class="{ 'is-invalid': errors.has('perfil') }"
              name="perfil"
              :disabled="data.item.status === STATUS_SUCCESS"
              required
              @change="mudarPerfil($event, data.item)">
        <option v-for="item in profiles"
                :key="item.id"
                :value="item.id"
                :selected="data.item.codigo_perfil_ged === item.id">
          {{ item.desc }}
        </option>
      </select>
    </template>

    <template slot="imagem"
              slot-scope="data">
      <b-button v-if="data.item.file && data.item.status != 'STATUS_SUCCESS'"
                class="col-5 mr-2"
                variant="danger"
                @click="removeSelectFile(data.item)">
        Excluir
      </b-button>
      <b-button v-if="data.item.file"
                v-b-modal.previewModal
                :class="data.item.status != 'STATUS_SUCCESS' ? 'col-6' : 'col'"
                variant="outline-secondary"
                @click="onPreviewClick(data.item)">
        Visualizar
      </b-button>
      <FileUpload v-if="!data.item.file"
                  :disabled="data.item.status === STATUS_SUCCESS"                  
                  label="Buscar imagem"
                  :prop-item="data.item"
                  :sm="true"
                  @onSelectFiles="onSelectFiles" />
    </template>
  </b-table>
</template>

<script>
  import moment from 'moment'
  
  // SVG
  import cloud_check from '@/assets/icons/cloud-check.svg?sprite'
  import cloud_error from '@/assets/icons/cloud-error.svg?sprite'
  import cloud_upload from '@/assets/icons/cloud-upload.svg?sprite'
  
  // Components
  import ServerError from '@/components/ServerError'
  import FileUpload from '@/components/SofiaRei/Upload/FileUpload'
  
  // Constants
  import { STATUS_PENDING, STATUS_SUCCESS, STATUS_ERROR } from '@/constants/fileUpload'


  export default {
    name: 'GridLoteArquivos',
    components: {
      ServerError,
      FileUpload
    },
    props: {
      arquivos: {
        type: Array,
        default: []
      },
      dataAverbAll: {
        type: String,
        default: null
      },
      profiles: {
        type: Array,
        default: null
      },
    },
    data () {
      return {
        // Icons
        cloud_error,
        cloud_check,
        cloud_upload,

        // Constants
        STATUS_PENDING,
        STATUS_SUCCESS,
        STATUS_ERROR,

        // Table
        fields: [
          // {
          //   key: 'flag_isento',
          //   sortable: false,
          //   label: 'Isento'
          // thClass: 'header-table'
          // },
          {
            key: 'data_documento',
            sortable: false,
            label: 'Data de Averbação',
            thClass: 'header-table'
          },
          {
            key: 'documento',
            sortable: true,
            label: 'Documento',
            thClass: 'header-table',
          },
          {
            key: 'registro',
            sortable: true,
            label: 'Registro',
            thClass: 'header-table',
          },
          {
            key: 'status',
            label: 'Status',
            thClass: 'header-table'
          },
          {
            key: 'perfil',
            label: 'Perfil',
            thClass: 'header-table'
          },
          {
            key: 'imagem',
            label: 'Imagem',
            thClass: 'header-table'
          },
        ],
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY')
      }
    },
    methods: {
      disableDataDoc (data) {
        if ([6, 7, 8, 9, 10].indexOf(this.perfil) != -1) {
          return (!data.item.flag_isento || data.item.disabled)
        }

        return true
      },
      changeDataAverb (data) {
        data.item.data_documento = data.item.data_documento || null
      },
      changeItemIsento (data) {
        data.item.data_documento = data.item.flag_isento ? this.dataAverbAll : data.item.data_documento
      },
      onPreviewClick (item) {
        const fileObj = {
          active: true,
          file: item.file,
          url: URL.createObjectURL(item.file)
        }

        this.$store.dispatch('file/addPreview', fileObj).then(result => result)
      },
      removeSelectFile (item) {
        this.$emit('removeSelectedFiles', item)
      },
      onSelectFiles (file, item) {
        item.fileName = file[0].name
        this.$emit('onSelectFiles', file, item)
      },
      mudarPerfil (newVal, item) {
        // Atualiza o codigo do perfil do documento
        this.$emit('atualizarPerfil', Number(newVal.target.value), item)
      }
    }
  }
</script>

<style scope>
  .header-table {
    background-color: #01bfa5;
    font-size: 18px;
  }
  .documento-box {
    max-width: 275px;
  }
</style>
